<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16"
  >
    <div class="px-6">
      <div class="flex flex-wrap justify-center">
        <div class="w-full px-4 flex justify-center">
          <div class="relative">
            <img
              alt="..."
              :src="currentUserAvatar"
              class="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
            />
          </div>
        </div>
        <div class="w-full px-4 text-center mt-20">
          <div class="flex justify-center py-4 lg:pt-4 pt-8">
            <div class="mr-4 p-3 text-center">
              <span
                class="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
              >
                99
              </span>
              <span class="text-sm text-blueGray-400">Happiness</span>
            </div>
            <div class="mr-4 p-3 text-center">
              <span
                class="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
              >
                99
              </span>
              <span class="text-sm text-blueGray-400">Joy</span>
            </div>
            <div class="lg:mr-4 p-3 text-center">
              <span
                class="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
              >
                99
              </span>
              <span class="text-sm text-blueGray-400">Pleasure</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-12">
        <h3
          class="text-xl font-semibold leading-normal mb-2 text-blueGray-700 mb-2"
        >
          {{ currentUser.email }}
        </h3>
        <div
          class="text-sm leading-normal mt-0 mb-2 text-blueGray-400 font-bold uppercase"
        >
          <i class="fas fa-map-marker-alt mr-2 text-lg text-blueGray-400"></i>
          Gold Coast, Queensland
        </div>
      </div>
      <div class="mt-10 py-10 border-t border-blueGray-200 text-center">
        <div class="flex flex-wrap justify-center">
          <div class="flex flex-row justify-between w-full lg:w-9/12 px-4">
            <div class="mb-4 text-lg leading-relaxed text-blueGray-700">
              Last Login: {{ currentUserLastSignInTime }}
            </div>
            <div class="mb-4 text-lg leading-relaxed text-blueGray-700">
              Creation Time: {{ currentUserCreationTime }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Helpers from "@/helpers";

export default {
  computed: {
    currentUserLastSignInTime() {
      if (Object.keys(this.currentUser).length !== 0) {
        return this.currentUser.metadata.lastSignInTime;
      } else {
        return "";
      }
    },
    currentUserCreationTime() {
      if (Object.keys(this.currentUser).length !== 0) {
        return this.currentUser.metadata.creationTime;
      } else {
        return "";
      }
    },
    currentUserAvatar() {
      return Helpers.getAvatar(this.currentUser.email);
    },
    ...mapGetters(["currentUser"])
  }
};
</script>
